var SCRIPTS_LOADING = {};
var addScript = function addScript(url, attributes) {
  if (attributes === void 0) {
    attributes = [];
  }
  var createScript = function createScript(resolve) {
    SCRIPTS_LOADING[url] = true;
    var script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = function () {
      SCRIPTS_LOADING[url] = false;
      resolve();
    };
    attributes.forEach(function (_ref) {
      var key = _ref.key,
        value = _ref.value;
      script[key] = value;
    });
    return script;
  };
  return new Promise(function (resolve) {
    var query = document.querySelector("script[src=\"" + url + "\"");
    if (query) {
      var prevCallback = query.onload;
      if (SCRIPTS_LOADING[url] && prevCallback) {
        query.onload = function () {
          prevCallback();
          resolve();
        };
      } else {
        resolve();
      }
    } else {
      SCRIPTS_LOADING[url] = true;
      var script = createScript(resolve);
      document.body.appendChild(script);
    }
  });
};
module.exports = addScript;